/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable import/prefer-default-export */
// import _ from 'lodash';

const ctrlTypeNameMap = {
  text_input: 'Text Input',
  number_input: 'Number Input',
  email: 'Email',
  text_area: 'Long Text',
  signature: 'Signature',
  media_header: 'Media Header',
  media_image: 'Media Image',
  file_upload: 'File Upload',
  labeled_input: 'Labeled Input',
  prepended_text: 'Prepended Text',
  appended_text: 'Appended Text',
  website: 'Website',
  datetime: 'Datetime',
  select_basic: 'Select Basic',
  select_multiple: 'Select Multiple',
  checkboxes: 'Checkbox',
  inline_checkboxes: 'Inline Checkboxes',
  radio_buttons: 'Radio Buttons',
  inline_radios: 'Inlin Radios',
  image_choice: 'Image Choice',
  description: 'Description',
  embed_field: 'Embed Field',
  star_rating: 'Star Rating',
  heart_rating: 'Heart Rating',
  scale_rating: 'Scale Rating',
  matrix_rating: 'Matrix rating',
  smiley_rating: 'Smiley Rating',
  table_field: 'Table Field',
  lookup: 'Lookup',
  duration: 'Duration',
  paypal: 'Paypal',
  stripe: 'Stripe',
  flutterwave: 'Flutterwave',
  paystack: 'Paystack',
  add_row: 'Row',
  phone: 'Phone Number',
};

const difference = (obj1, obj2) => {
  if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
    return obj1;
  }
  const diffs = {};
  let key;

  const arraysMatch = function (arr1, arr2) {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) return false;

    // Check if all items exist and are in the same order
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    // Otherwise, return true
    return true;
  };

  const compare = function (item1, item2, key) {
    const type1 = Object.prototype.toString.call(item1);
    const type2 = Object.prototype.toString.call(item2);

    if (type2 === '[object Undefined]') {
      diffs[key] = null;
      return;
    }

    if (type1 !== type2) {
      diffs[key] = item2;
      return;
    }

    if (type1 === '[object Object]') {
      const objDiff = difference(item1, item2);
      if (Object.keys(objDiff).length > 0) {
        diffs[key] = objDiff;
      }
      return;
    }

    if (type1 === '[object Array]') {
      if (!arraysMatch(item1, item2)) {
        diffs[key] = item2;
      }
      return;
    }

    if (type1 === '[object Function]') {
      if (item1.toString() !== item2.toString()) {
        diffs[key] = item2;
      }
    } else if (item1 !== item2) {
      diffs[key] = item2;
    }
  };

  for (key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      compare(obj1[key], obj2[key], key);
    }
  }

  return diffs;
};

export const compareForm = (initialFormDefinition, newDefinition, reversed) => {
  const oldFormDefinition = initialFormDefinition;
  const currentFormDefinition = newDefinition;
  if (reversed) return difference(oldFormDefinition, currentFormDefinition);

  return difference(currentFormDefinition, oldFormDefinition);
};

export const getFormCreatedMetadata = (formPages, formName, newFormId) => {
  let numberFields = 0;
  const fieldsInForm = [];
  const fieldIdsInForm = [];
  if (!formPages) {
    return [
      {
        'Form Name': formName,
        'Form Created Date': new Date().toISOString(),
        'Form ID': newFormId?.toString(),
        'Number of Fields': numberFields,
        'Created Form': 'Scratch',
        'Template ID': '',
        'Fields in Form': fieldsInForm,
      },
      [],
    ];
  }

  for (let i = 0; i < formPages.length; i++) {
    const currPage = formPages[i];
    if (currPage && currPage.controls) {
      for (let j = 0; j < currPage.controls.length; j++) {
        const currCtrl = currPage.controls[j];
        if (currCtrl !== undefined) {
          numberFields += 1;
          if (fieldsInForm.indexOf(ctrlTypeNameMap[currCtrl.type]) === -1) {
            fieldsInForm.push(ctrlTypeNameMap[currCtrl.type]);
          }
          if (currCtrl.internal_id) {
            fieldIdsInForm.push(currCtrl.internal_id);
          }
        }
      }
    }
  }
  return [
    {
      'Form Name': formName,
      'Form Created Date': new Date().toISOString(),
      'Form ID': newFormId?.toString(),
      'Number of Fields': numberFields,
      'Multi Page Form?': formPages.length > 1,
      'Created Form': 'Scratch',
      'Template ID': '',
      'Fields in Form': fieldsInForm,
    },
    fieldIdsInForm,
  ];
};

const getFieldOptionsMetadata = (builderForm, ctrlId) => {
  const shortTextType = { 0: 'Text', 1: 'Number', 2: 'Email' };
  const datetimeType = { 0: 'Datetime', 1: 'Date', 2: 'Time' };
  const lookupType = { 0: 'Basic', 1: 'Autofill' };
  const ctrl = builderForm.pages[ctrlId];
  switch (ctrl.type) {
    case 'text_input':
      return {
        'Short Text Type': shortTextType[ctrl.props.type],
        'Added Default Value': ctrl.props.default !== null && ctrl.props.default !== '',
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Used Validation?':
          (ctrl.props.min_length !== null && ctrl.props.min_length !== '') ||
          (ctrl.props.max_length !== null && ctrl.props.max_length !== ''),
        'Internal ID': ctrlId,
      };
    case 'number_input':
    case 'email':
      return {
        'Added Default Value': ctrl.props.default !== null && ctrl.props.default !== '',
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'text_area':
      return {
        'Used Validation?':
          (ctrl.props.min_word_length !== null && ctrl.props.min_word_length !== '') ||
          (ctrl.props.max_word_length !== null && ctrl.props.max_word_length !== ''),
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'datetime':
      return {
        'Datetime Type': datetimeType[ctrl.props.type],
        'Date Format': ctrl.props.date_format,
        'Separator Type': ctrl.props.separator,
        'Time Format': ctrl.props.time_format,
        'Single or Multiple Dates?': ctrl.props.mode === 'single' ? 'Single' : 'Multiple',
        'Set Default Date?': ctrl.props.default !== '',
        'Use `Today` as Default Date?': ctrl.props.now,
        'Set Default Time?': ctrl.props.default !== '',
        'Use Current Time as Default Time?': ctrl.props.now,
        'Disabling Days of the Week?': ctrl.props.disabled_days.length > 0,
        'Disabling Past Dates?': ctrl.props.past,
        'Disabling Future Dates?': ctrl.props.future,
        'Disabling Past Time?': ctrl.props.past,
        'Disabling Future Time?': ctrl.props.future,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'labeled_input':
      return {
        'Used Validation?':
          (ctrl.props.min_length !== null && ctrl.props.min_length !== '') ||
          (ctrl.props.max_length !== null && ctrl.props.max_length !== ''),
        'Labeled Text Type': shortTextType[ctrl.props.type],
        'Added Default Value': ctrl.props.default !== null && ctrl.props.default !== '',
        'Show Prepended Label': ctrl.props.prepended_text,
        'Show Appended Label': ctrl.props.appended_text,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'prepended_text':
      return {
        'Used Validation?':
          (ctrl.props.min_length !== null && ctrl.props.min_length !== '') ||
          (ctrl.props.max_length !== null && ctrl.props.max_length !== ''),
        'Labeled Text Type': shortTextType[ctrl.props.type],
        'Added Default Value': ctrl.props.default !== null && ctrl.props.default !== '',
        'Show Prepended Label': ctrl.props.prepended_text,
        'Show Appended Label': ctrl.props.appended_text,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'website':
      return {
        'Added Default Value': ctrl.props.default !== null && ctrl.props.default !== '',
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'table_field':
      return {
        'Table Field Control Types': ctrl.props.column_types.map(function (type) {
          return ctrlTypeNameMap[type];
        }),
        'Required?': ctrl.props.required,
        'Internal ID': ctrlId,
      };
    case 'signature':
      return {
        'Renaming File': ctrl.props.rename && ctrl.props.rename.enabled,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Internal ID': ctrlId,
      };
    case 'lookup':
      return {
        'Lookup Type': lookupType[ctrl.props.lookup_type],
        'Lookup Field Type': ctrlTypeNameMap[ctrl.props.field_type],
        'Source Form ID': ctrl.props.form,
        'Required?': ctrl.props.required,
        'Internal ID': ctrlId,
      };
    case 'select_basic':
    case 'select_multiple':
      return {
        'Assigned Values to Options?': ctrl.props.option_values,
        'Enabled `Other` Option?': ctrl.props.other && ctrl.props.other.enabled,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Internal ID': ctrlId,
      };
    case 'checkboxes':
    case 'inline_checkboxes':
    case 'inline_radios':
    case 'radio_buttons':
      return {
        'Used Validation?': ctrl.props.min_selections !== null || ctrl.props.max_selections !== null,
        'Assigned Values to Options?': ctrl.props.option_values,
        'Enabled `Other` Option?': ctrl.props.other && ctrl.props.other.enabled,
        'Options Displayed Inline?': ctrl.props.inline,
        'Shuffling Options Randomly?': ctrl.props.shuffle_options,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'image_choice':
      return {
        'Image Size': ctrl.props.image_size,
        'Single or Multiple Selections?': ctrl.props.rating_type === 'radio' ? 'Single' : 'Multiple',
        'Assigned Values to Options?': ctrl.props.option_values,
        'Enabled `Other` Option?': ctrl.props.other && ctrl.props.other.enabled,
        'Options Displayed Inline?': ctrl.props.inline,
        'Shuffling Options Randomly?': ctrl.props.shuffle_options,
        'Showing Labels?': ctrl.props.show_labels,
        'Number of Images': ctrl.props.images.length,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Internal ID': ctrlId,
      };
    case 'star_rating':
      return {
        'Number of Stars': ctrl.props.stars_count,
        'Assigned Values to Options?': ctrl.props.option_values,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'heart_rating':
      return {
        'Number of Hearts': ctrl.props.hearts_count,
        'Assigned Values to Options?': ctrl.props.option_values,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'scale_rating':
      return {
        'Number of Scales': ctrl.props.scale_count,
        'Options Displayed Inline': ctrl.props.inline,
        'Assigned Values to Options?': ctrl.props.option_values,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Readonly?': ctrl.props.readonly,
        'Internal ID': ctrlId,
      };
    case 'matrix_rating':
      return {
        'Number of Columns': ctrl.props.column_headers.length,
        'Number of Rows': ctrl.props.row_headers.length,
        'Field Type': ctrl.props.rating_type,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Internal ID': ctrlId,
      };
    case 'smiley_rating':
      return {
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Internal ID': ctrlId,
      };
    case 'file_upload':
      return {
        'Renaming File?': ctrl.props.rename && ctrl.props.rename.enabled,
        'File Size Validation?': ctrl.props.max_file_size != null && ctrl.props.max_file_size > 0,
        'File Category Validation?': ctrl.props.file_categories != null && ctrl.props.file_categories.length > 0,
        'File Extension Validation?': ctrl.props.file_extensions != null && ctrl.props.file_extensions.length > 0,
        'Required?': ctrl.props.required,
        'Hidden?': ctrl.props.hidden,
        'Internal ID': ctrlId,
      };
    case 'paypal':
      return {
        'Amount From Calculation?': '??',
        Currency: ctrl.props.currency,
        'Required?': ctrl.props.required,
        'Internal ID': ctrlId,
      };
    case 'stripe':
      return {
        'Amount From Calculation?': '??',
        'User can Specify Amount?': ctrl.props.user_specify,
        Currency: ctrl.props.currency,
        'Enabled Billing Address?': ctrl.props.billing_address,
        'Enabled Save Card to Stripe?': ctrl.props.save_card_stripe,
        'Using Stripe Subscriptions?': ctrl.props.list_products,
        'Sending Additional Information to Stripe?':
          ctrl.props.metadata[0].key !== '' && ctrl.props.metadata[0].value !== '',
        'Number of Additional Information Sent':
          ctrl.props.metadata[0].key !== '' && ctrl.props.metadata[0].value !== '' ? ctrl.props.metadata.length : 0,
        'Required?': ctrl.props.required,
        'Internal ID': ctrlId,
      };
    case 'paystack':
      return {
        'Amount From Calculation?': '??',
        'User can Specify Amount?': ctrl.props.user_specify,
        Currency: ctrl.props.currency,
        'Required?': ctrl.props.required,
        'Internal ID': ctrlId,
      };
    case 'media_image':
      return {
        'Image Added Via?': '??',
        'Image Position': ctrl.props.placement,
        'Internal ID': ctrlId,
      };
    case 'add_row':
      return {
        'Fields in Row': ctrl.props.controls.map(function (controlId) {
          if (builderForm.pages[controlId]) {
            return ctrlTypeNameMap[builderForm.pages[controlId].type];
          }
          return '';
        }),
        'Internal ID': ctrlId,
      };
    case 'embed_field':
      return {
        'Internal ID': ctrlId,
      };
    default:
      return {};
  }
};

export const enabledSubmissionEditMetadata = (form) => {
  return {
    'Notifications After Edit': form.options.notifications_after_edit,
    'Autoresponders After Edit': form.options.confirmation_emails_after_edit,
    'Edit Deadline': form.options.edit_deadline ? true : false,
  };
};

export const enabledEmailNotificationMetadata = (form) => {
  var notificationTypes = {
    submission: 'On Submission',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
  };

  return {
    'Notification Type': form.notification_type !== 'off' ? notificationTypes[form.notification_type] : null,
    'Response in Notification': form.include_response_in_notification,
    'Notification to Others?': form.notification_emails.length > 0,
    'Notification Attachment': Boolean(form.notification_attachment_format),
    'Attachment Format': form.notification_attachment_format,
  };
};

export const addedAutoresponderMetadata = (form) => {
  return {
    'Added Custom Message?': form.autoresponder_message != null && form.autoresponder_message != '',
    'Included Data?':
      form.autoresponder_message &&
      form.autoresponder_message.indexOf('{{') > 0 &&
      form.autoresponder_message.indexOf('}}') > 0,
  };
};

export const transferredFormMetadata = (copyResults) => {
  return {
    'Transferred with data?': copyResults,
  };
};

export const enabledPaymentTestMode = (type) => {
  return {
    'Payment Type': type == 'paypal' ? 'Paypal' : type == 'stripe' ? 'Stripe' : 'Paystack',
  };
};

export const sendFormFieldsMetadata = (builderForm, fieldIds, reversed) => {
  let action;
  let trackingMessage;
  if (reversed) action = 'Deleted';
  else action = 'Added';

  for (let j = 0; j < fieldIds.length; j++) {
    const ctrl = builderForm.pages[fieldIds[j]];
    if (!ctrl) continue;
    if (ctrl.type === 'embed_field') {
      trackingMessage = 'Embedded Video in Form';
    } else {
      trackingMessage = `${action} ${ctrlTypeNameMap[ctrl.type]} Field`;
    }
    const fieldTypeData = getFieldOptionsMetadata(builderForm, fieldIds[j]);
    window.mixpanel.track(trackingMessage, fieldTypeData);
  }
};
